import * as React from 'react';
import './ReturnsOptions.scss';
import RadioButton from 'src/components/common/RadioButton';
import Dropdown from 'src/components/common/Dropdown';

export const ADD_EXISTING = 'addExisting';
export const ADD_NEW = 'addNew';
export const SAVE_FOR_LATER = 'saveForLater';
export const SUBMIT_NOW = 'submitNow';

interface IReturnsOptionsProps {
  rmaList: string[];
  selectedOption: string;
  handleChangeOption: (e: any) => void;
  poNumber: string;
  rmaSelected: string;
  handlePoNumber: (e: any) => void;
  handleSelectedRma: (value: string) => void;
  t?: any;
}

const ReturnsOptions: React.FC<IReturnsOptionsProps> = props => {
  const {
    rmaList,
    poNumber,
    handlePoNumber,
    handleSelectedRma,
    rmaSelected,
    selectedOption,
    handleChangeOption,
    t
  } = props;

  const getSelectedOption = () => {
    const options = {
      addExisting: false,
      addNew: false
    };

    options[selectedOption] = true;
    return options;
  };

  const selection = getSelectedOption();

  return (
    <div className="rp-returns-options">
      <div className="rp-returns-options-existing">
        <RadioButton
          name={t('myReturns.addExistingReturn')}
          className="rp-returns-options-radio"
          value={ADD_EXISTING}
          checked={selection.addExisting}
          onChange={handleChangeOption}
        />

        <div className="rp-returns-options-dropdown">
          <label
            className={`rp-returns-options-label ${selectedOption !==
              ADD_EXISTING && 'disabled'}`}
          >
            Select Return No.
          </label>
          <Dropdown
            options={rmaList.map(rma => ({ label: rma, value: rma }))}
            disabled={selectedOption !== ADD_EXISTING}
            onSelected={handleSelectedRma}
            activeOption={rmaSelected}
          />
        </div>
      </div>
      <div className="rp-returns-options-new">
        <RadioButton
          name={t('myReturns.createNewreturn')}
          className="rp-returns-options-radio"
          value={ADD_NEW}
          checked={selection.addNew}
          onChange={handleChangeOption}
        />

        <div className="rp-returns-options-input">
          <label
            className={`rp-returns-options-label ${selectedOption !== ADD_NEW &&
              'disabled'}`}
          >
            {t('myReturns.pONumber')} ({t('common.optional')})
          </label>
          <input
            type="text"
            value={poNumber}
            onChange={handlePoNumber}
            disabled={selectedOption !== ADD_NEW}
            className="rp-returns-options-in"
            maxLength={15}
          />
        </div>
      </div>
    </div>
  );
};

export default ReturnsOptions;
